import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useScript } from "../../../utils/CustomHooks/useScript";
import { getLocalSessionData, setLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, PAYMENT_TYPE, SIGNUPTYPE, PAYMENT_OPTIONS } from "../../../constants/AppConstants";
import { _CALLPOSTAPI, _CALLPOSTAPI_WITHQS } from "../../../api/apiHandler";
import { createSubscription } from "../../ZuoraPayment/ZuoraPayment";
import { UpdatePaymentInfoContext } from "../../../pages/Account/EditAccount/EditPayment";
import SubscriptionOrderPayload from "../../../utils/MyAccount/SubscriptionOrderPayload";
import { WEB_handleSelectedPlanLocalData } from "../../../utils/Authentication/handleUserSession";
import { Is_HWInclusive_Signup } from "../../../constants/AppMethod";
import './ZuoraGpayPayment.css';
import { useTranslation } from "react-i18next";
import { getLangCode } from "../../../utils/Internationalization/handleAppInternationalization";

// Pass publishableKey and accountId as props or from config
const GooglePay = ({ publishableKey, paymentType }) => {
      const dispatch = useDispatch();
      let paymentRefID = null;
      const paymentTypeConfig = ( paymentType === PAYMENT_TYPE.UPDATE ) ? PAYMENT_TYPE.UPDATE : PAYMENT_TYPE.NEW; 
      const fetchedMyAccount = useContext(UpdatePaymentInfoContext)?.accountInfo;
      const MyAccount = useSelector((state) => state.MyAccount);
      const ZuoraPaymentInfo = useSelector(state => state.ZuoraPaymentInfoRendering);
      const SelectedPlan = useSelector(state => state.MyPlan);
      const { fetchAddress_data } = useSelector(state => state.ROOTREDUCER_RTK.fetchAddressService);
      const device_id = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
      const signUpType = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);
      const locale = getLangCode()
      const countryCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE);
      const { isUpgradeInitiated } = useSelector(state => state.UpgradeToEcoProStatus);
      const IsHWInclusive_Signup = Is_HWInclusive_Signup();
      const planDetails = WEB_handleSelectedPlanLocalData('Get');
      const deviceInfoResult = useSelector((state) => state.DashboardDeviceInfo);
      const { t } = useTranslation(['translation']);
      const [showApiError, setShowApiError] = useState(false);

      const [formLoaded, setFormLoaded] = useState(false);
      let { currency, HWPlans, amount } = '';

      if( paymentType === PAYMENT_TYPE.UPDATE ){
        currency = deviceInfoResult?.deviceInfo?.service?.currentPlan?.currency;
        amount = deviceInfoResult?.deviceInfo?.service?.currentPlan?.price;
      }
      else{
        currency = ( signUpType === SIGNUPTYPE.WEB || signUpType === SIGNUPTYPE.HARDWARE_INCLUSIVE ) ? planDetails?.currency : SelectedPlan?.selected_plan?.currency;
        amount = ( signUpType === SIGNUPTYPE.WEB || signUpType === SIGNUPTYPE.HARDWARE_INCLUSIVE ) ? planDetails?.price : SelectedPlan?.selected_plan?.price;
        HWPlans = ( signUpType === SIGNUPTYPE.WEB || signUpType === SIGNUPTYPE.HARDWARE_INCLUSIVE ) ? planDetails?.HWPlans : SelectedPlan?.selected_plan?.HWPlans;
      }

      let deviceAddressList = fetchAddress_data?.deviceAddress;
      const matchedAddress = isUpgradeInitiated
          ? deviceAddressList.filter((address) => { return (address.deviceId === device_id) })[0]
          : null;
    amount = IsHWInclusive_Signup ? HWPlans?.discountedPrice : "0.00";

  useScript("https://js.zuora.com/payment/sandbox/1.4.0/zuora.js", () => {
    if (window.Zuora && !document.getElementById('payment-form-container').hasChildNodes()) {
      renderForm();
    }
  });

  const queryString = {
    params: {
        userId: getLocalSessionData(LOCALSESSIONDATAKEYS.UID),
        country: getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE)
    }
  }
  const endpoint = _API_ENDPOINT.CREATE_GPAY_PAYMENT_SESSION;
  const manageSubsEndpoint = _API_ENDPOINT.SUBSCRIPTION_MANAGE;
  const {paymentID, subscriptionPayload, isUpgradeInitiated1, addressId} = createSubscription({paymentRefID, paymentType : paymentTypeConfig, fetchedMyAccount, MyAccount, ZuoraPaymentInfo, signUpType, SelectedPlan, isUpgradeInitiated, matchedAddress}, {dispatch}, true)
  let manageSubsPayload = '';
  SubscriptionOrderPayload(paymentID, subscriptionPayload, isUpgradeInitiated1, addressId).then( (res) => {
    manageSubsPayload = res;
  } )

  const renderForm = () => {
    const zuora = window.Zuora(publishableKey);

    zuora
      .createGooglePayButton({
        countryCode: countryCode,
        locale: locale,
        currency: currency,
        amount: amount,
        allowedCardNetworks: ["AMEX", "MASTERCARD", "VISA"],
        buttonHeight: "40px",
        buttonRadius: "5px",
        buttonColor: "black",
        buttonType: "pay",


        // Replace fetch with axios wrapper
        createPaymentSession: () => {
          setShowApiError(false);
          return new Promise( (resolve, reject) => {              
             _CALLPOSTAPI(manageSubsEndpoint, manageSubsPayload )
              .then(subscriptionResp => {
                if(subscriptionResp.actionStatus === "Success"){
                    _CALLPOSTAPI_WITHQS(endpoint,'', queryString)
                  .then((res) => {
                    if (res?.token) {
                      setLocalSessionData(LOCALSESSIONDATAKEYS.PAYMENT_TYPE,  PAYMENT_OPTIONS.GOOGLE_PAY)
                      return resolve(res.token);
                    } else {
                      return reject("No token in response");
                    }
                  })
                  .catch((err) => { 
                    return reject(err) } );
                }
                else{
                  setShowApiError(true);
                }
              })
             .catch((error) => {
                  throw error;
              });
          })
        },

        onComplete: (result) => {
          paymentRefID = result.paymentMethodId;
          document.getElementById("paymentRefID").value = paymentRefID;
          document.getElementById("card_info_submit").click();
        },
      })
      .then((googlePayButton) => {
        googlePayButton.mount("#payment-form-container");
        setFormLoaded(true);
      })
      .catch((err) => console.error(err));
  };

  return (
    <div>
      { showApiError && 
        <div className="alert alert-danger"> 
          {t("VERIFY_PAYMENT_DETAILS")}
        </div> }
      <div id="payment-form-container"></div>
      { formLoaded &&
        <div class="payment-divider-div"> {t("PAYMENT_OPTIONS_DIVIDER.OR")} </div>
  }
    </div>
  );
};

export default GooglePay;
